
import React from "react";
import {Container, Row, Col} from "react-bootstrap";
import Header from "./Header";
import Footer from "./Footer";
import GeneralInformation from "./GeneralInformation";
import LicenseInformation from "./LicenseInformation";
import OverallHealthKpi from "./OverallHealthKpi";
import HardwarePerformance from "./HardwarePerformance";
import UserInterfacePerformance from "./UserInterfacePerformance";
import CommunicationPerformance from "./CommunicationPerformance";
import ApplicationPerformance from "./ApplicationPerformance";
import HistoryPerformance from "./HistoryPerformance";


function App({data}) {

// console.log(data);

    function formatTime(utc) {
        // console.log(utc);
        let date = new Date(utc);
        let format = date.toUTCString();
        // console.log(format);
        return format;

    }


    // @ts-ignore
    return (
        <Container id="container" className="h-100 container-sm">
            <Header id="header"></Header>
            <Container id="content">
                <Row>
                    <Col sm={7}>
                        <Row>
                            <GeneralInformation data={data.generalInformation}></GeneralInformation>
                        </Row>
                        <Row>
                            <LicenseInformation data={data.licenseInformation}></LicenseInformation>
                        </Row>
                        <Row>
                            <HardwarePerformance data={data.hardwarePerformance}></HardwarePerformance>
                        </Row>
                        <Row>
                            <CommunicationPerformance data={data.communicationsPerformance}></CommunicationPerformance>
                        </Row>
                    </Col>
                    <Col sm={5}>
                        <Row>
                            <OverallHealthKpi data={data.healthKpi}></OverallHealthKpi>
                        </Row>
                        <Row>
                            <UserInterfacePerformance data={data.userInterfacePerformance}></UserInterfacePerformance>
                        </Row>
                        <Row>
                            <HistoryPerformance data={data.historyPerformance}></HistoryPerformance>
                        </Row>
                        <Row>
                            <ApplicationPerformance data={data.applicationPerformance}></ApplicationPerformance>
                        </Row>

                    </Col>
                </Row>


            </Container>

            <Footer time={formatTime(data.generalInformation.currentTime)}></Footer>

        </Container>

    );
}

export default App;
